import type { ContextualUIProps } from 'owa-acui';
import type * as lazyIndex from './lazyIndex';
import { LazyAction, type LazyComponent, LazyModule, createLazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "AcuiLazy"*/ './lazyIndex'),
    {
        name: 'AcuiLazy',
    }
);

export const lazyGetDefaultRibbonControlInMenuRendererFunction: LazyAction<
    typeof lazyIndex.getDefaultRibbonControlInMenuRendererFunction,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getDefaultRibbonControlInMenuRendererFunction);

export const ContextualUI: LazyComponent<ContextualUIProps, lazyIndex.ContextualUI, void> =
    createLazyComponent(lazyModule, m => m.ContextualUI);
